<template>
  <div class="checkbox-container">
    <label :for="randomIdKey">
      <input
        type="checkbox"
        :id="randomIdKey"
        :checked="isChecked"
        @click="$emit('updateValue', value)"
      >
      <span class="checkbox">
        <Checkmark />
      </span>
      {{value}}
    </label>
  </div>
</template>

<script>
import Checkmark from '@/components/assets/Checkmark';
import { getRandomIdKey } from '@/utilities/math.utilities'

export default {
  name: 'Checkbox',
  components: {
    Checkmark
  },
  props: {
    value: {
      required: true
    },
    isChecked: {
      type: Boolean
    }
  },
  computed: {
    randomIdKey() {
      return getRandomIdKey()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';

.checkbox-container {
  box-sizing: border-box;
  padding: 16px 0;

  @media (min-width: 600px) {
    display: inline-block;
    width: 50%;
    padding: 6px 0;

    &:nth-child(odd) {
      padding-left: 16px;
    }
  }
}

.checkbox {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border: 1px solid $gd-black;
  border-radius: 2px;
  margin-right: 18px;
}

label {
  @include flex(row, flex-start, center);
  font-size: 14px;
  cursor: pointer;
}

input {
  opacity: 0;
  position: absolute;

  &:checked {

    + .checkbox {
      background: $gd-blue;
      border-color: $gd-blue;

      svg {
        display: block;
      }
    }
  }
}

svg {
  position: absolute;
  bottom: -1px;
  right: -1px;
  display: none;
}

form.disabled {

  .checkbox {
    background: $gd-gray;
    border-color: transparent;
  }

  label {
    color: $gd-gray;
    cursor: default;
    pointer-events: none;
  }

  input {
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form-elements/Checkbox.vue